module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "1 Lessons Lived, Learned, Lost"
    }
  }, [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('i', [_vm._v("1")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "chtitle"
  }, [_vm._v("Lessons Lived, Learned, Lost")]), _vm._v(" "), _c('p', {
    staticClass: "chtitle1"
  }, [_vm._v("Episodic Progress in U.S. and British Experiences in Coalition Warfare, 1900–1918")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("We have learned a lot from the last war in these [coalition] matters—it is good we should so rapidly apply that knowledge and plunk for the right thing from the very beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("—Sir Henry Pownall, Chief of General Staff, British Expeditionary Force (1939), "), _c('i', [_vm._v("Chief of Staff")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Dealing with the enemy is a simple and straightforward matter when contrasted with securing close cooperation with an ally.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("—Major General Fox Conner, Chief of Operations, American Expeditionary Force (1918), “The Allied High Command and Allied Unity of Direction,” speech to the Army War College, 1940")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Before examining Anglo-American military cooperation during the period 1937–1941, some understanding of the previous experiences in coalition warfare, the so-called intellectual baggage that each power brought to the discussions, is essential. In this instance, the respective British and U.S. experiences leading up to and during World War I offer a suitable starting point.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Throughout the nineteenth century, the United States adhered to George Washington’s admonition to avoid foreign entanglements because exploration and consolidation of the continental hinterland absorbed American energies. After defeating Spain in 1898, however, the United States acquired substantial overseas territories for the first time and emerged on the international scene as a nascent global power. Many Americans, even if not totally isolationist, nonetheless remained suspicious of overseas involvement. However, with an increased military presence in the Pacific and the Caribbean as well as the special attitude of the United States toward China, elements of the American public began advocating a more active foreign policy, particularly in the Pacific.")]), _c('a', {
    attrs: {
      "id": "rch1en1"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" President Theodore Roosevelt’s brokering an end to the Russo-Japanese War, "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("for which he received the Nobel Peace Prize of 1906, creation of a modern “blue water” navy, and the circumnavigation of the globe by the Great White Fleet in 1907–1909 manifested the emergence of the United States as a major power.")]), _c('a', {
    attrs: {
      "id": "rch1en2"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the same time, impediments to extensive collaboration abroad remained. The U.S. military establishment was not prepared for large-scale collaborative efforts. The army constituted little more than a constabulary force, and weaknesses in its organization and structure discovered during the Spanish-American War would take more than a decade to resolve. The U.S. Navy—preeminent U.S. naval theorist Rear Admiral Alfred Thayer Mahan, and Roosevelt’s Great White Fleet notwithstanding—was not yet a modern navy equal to European standards. As a result, the armed services remained preoccupied with the demands of the defense of the Western Hemisphere."), _c('a', {
    attrs: {
      "id": "rch1en3"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Moreover, U.S. political leaders after Roosevelt sought to preserve U.S. neutrality in world affairs. For example, in his biography of Newton D. Baker, U.S. secretary of war during World War I, Frederick Palmer notes that in 1915 President Woodrow Wilson saw an article in the "), _c('i', [_vm._v("Baltimore Sun")]), _vm._v(" indicating that the army’s General Staff was preparing contingency plans for a possible war against Germany. The president ordered Henry S. Breckinridge, the acting secretary of war, to investigate the claim “and, if it proved true, to relieve at once every officer of the General Staff and order him out of Washington.”"), _c('a', {
    attrs: {
      "id": "rch1en4"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Wilson’s temper cooled after Secretary Baker informed him that it was the General Staff’s duty to prepare such plans, “but, Mr. Breckinridge directed me to caution the War College to ‘camouflage’ its work. It [the order] resulted in practically no further additional studies.”"), _c('a', {
    attrs: {
      "id": "rch1en5"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Great Britain, in contrast, began the twentieth century in the midst of the Boer War, 1899–1902, the last of the great wars to consolidate its empire."), _c('a', {
    attrs: {
      "id": "rch1en6"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Even before that conflict, Britain had begun to reassess its level of global engagement and emerge from self-imposed “splendid isolation” as it attempted to reduce the potential for conflicts. For example, after resolving a confrontation with the United States over Venezuela (1895–1896), British leaders sought rapprochement with the United States that would help secure U.S. interests in Asia as a quid pro quo for U.S. protection of British interests in the Western Hemisphere."), _c('a', {
    attrs: {
      "id": "rch1en7"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" A more pressing issue stemmed from Anglo-German competition after German unification that accelerated into rising tensions after Wilhelm II discarded Chancellor Otto von Bismarck in 1890 and seized control of German foreign policy. Faced with an increasingly menacing Wilhelmine Germany, Britain once more focused its attentions on the European balance of power and in particular on Britain’s role in maintaining that delicate equilibrium. The threat from Germany subsequently led to the Anglo-French Entente Cordiale "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("of 1904, the Anglo-Russian Entente of 1907, and British efforts to broker diplomatic solutions to the Balkan wars, all of which culminated in the outbreak of World War I and the commitment of British land forces to the Continent for the first time in almost sixty years.")]), _c('a', {
    attrs: {
      "id": "rch1en8"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the midst of the First Moroccan Crisis of March 1905–May 1906 between France and Germany over Moroccan independence, Britain and France began exploring the possibilities of military cooperation. The relationship started in December 1905 when Major Victor Huguet, the French military attaché in London, approached Major General James Grierson, director of military operations on the Imperial General Staff, and inquired about British intentions on the Continent. Grierson replied that the British had been examining the possible deployment of a 100,000- to 150,000-man force to northwestern Europe in the event of a general European war and that the British preferred to plan for operations in Belgium, but, if necessary, they could shift their focus to supporting the French left flank."), _c('a', {
    attrs: {
      "id": "rch1en9"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" A few days later, Huguet contacted his friend, Lieutenant Colonel (ret.) Charles à Court Repington, the influential military correspondent of the "), _c('i', [_vm._v("Times")]), _vm._v(" (London), and queried him about British plans. Repington contacted British officials, who agreed to use Repington as an informal conduit and posed several questions that Repington relayed to Huguet. Shortly thereafter, the British government decided to enter into direct staff talks and terminated Repington’s role."), _c('a', {
    attrs: {
      "id": "rch1en10"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Staff talks proceeded at a desultory pace during 1906–1910 as tension over Morocco cooled and Anglo-German relations warmed. Anglo-French planners designated ports of debarkation for what would become the British Expeditionary Force (BEF), specified initial assembly areas, and began plans for the forward rail transport of British forces. The fact that as early as 1908 the French decided to locate the BEF near Cambrai and Arras on the Belgian border but neglected to inform their British partners offers a revealing indication of the level of coalition cooperation."), _c('a', {
    attrs: {
      "id": "rch1en11"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Major General Henry Wilson’s accession to the post of director of military operations rejuvenated the staff conversations. Convinced that little practical work had been accomplished, Wilson, a close friend of General Ferdinand Foch and described by historian Roy Prete as “French speaking, ardently Francophile, and a convert to offensive doctrine,” immediately set about altering what he perceived to be a disgraceful state of unpreparedness."), _c('a', {
    attrs: {
      "id": "rch1en12"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" By August 1911, Wilson’s energetic efforts resulted in the planned deployment of a BEF of approximately 150,000 men on the French left flank."), _c('a', {
    attrs: {
      "id": "rch1en13"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" From this position, they would fall upon an anticipated open German right flank south of the Meuse River. Only later would Anglo-French commanders find out how badly they "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("had underestimated the scope of the sweeping envelopment of the Schlieffen Plan, the German plan to quickly conquer France. Now that they were already engaged in battle, it would be too late to draw up new plans. The BEF would have to execute the only plan it had—with near disastrous short-term results for the BEF as well as long-lasting strains within the coalition.")]), _c('a', {
    attrs: {
      "id": "rch1en14"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout 1912–1914, coalition planners concentrated on refining the general terms agreed upon in 1911. From the available evidence, Wilson appears to have been the principal, if not the sole, negotiator between the British and French staffs. It is clear that he was coordinating Anglo-French activities, not planning for combined operations of the two armies."), _c('a', {
    attrs: {
      "id": "rch1en15"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" There also are indications that Wilson may have made commitments he had not cleared with his civilian masters in the War Office, an omission that would have significant consequences in August 1914 when His Majesty’s Government did not immediately enter the war. British indecision not only delayed mobilization and movement of the BEF to France but also upset French mobilization and concentration timetables because the French had to wait for the British to move forward on their left flank. The delay also sowed seeds of French suspicions over ultimate British intent."), _c('a', {
    attrs: {
      "id": "rch1en16"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Contemporary French documents and Marshal Joseph Joffre’s memoirs indicate that when Joffre presented Plan XVII in April 1913, he noted, “I was conscious … that since the agreement was problematical and subject to political considerations, it was impossible to base "), _c('i', [_vm._v("a priori")]), _vm._v(", a strategic offensive upon eventualities which might very well never materialize.”"), _c('a', {
    attrs: {
      "id": "rch1en17"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" In this statement lies a key issue in coalition planning, especially prewar planning: key decisions about going to war rest ultimately in the hands of politicians, not soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("British and French naval authorities also carried out staff discussions during this period, albeit less extensive than those of their army colleagues. In the first meeting in January 1906, Admiral Sir John “Jacky” Fisher, the first sea lord, apparently lectured Captain Mercier de Lostende, the French naval attaché, about current British strategy and expressed the opinion that the Royal Navy could take care of itself."), _c('a', {
    attrs: {
      "id": "rch1en18"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" By November 1908, when the French resurrected naval conversations, the German Imperial Navy had evolved into a major threat. Fisher proposed that the Royal Navy would take responsibility for the North Sea, while the French Navy would defend the Mediterranean. Naval conversations lapsed shortly thereafter when de Lostende informed Fisher that although the French government agreed in principle, the French did not have sufficient strength to control the entire Mediterranean."), _c('a', {
    attrs: {
      "id": "rch1en19"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" The French reopened discussions in July 1911 during the second Franco-German crisis over Morocco."), _c('a', {
    attrs: {
      "id": "rch1en20"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Over the next year, Anglo-French naval authorities negotiated "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("an agreed division of labor: the British would patrol the North Sea, the Dover–Calais straits, and the Mediterranean Sea east of Malta, while the French would defend the lower English Channel and the Mediterranean west of Malta.")]), _c('a', {
    attrs: {
      "id": "rch1en21"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" These provisions stood when war broke out and remained in effect throughout the course of the war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to historian Samuel R. Williamson, despite the staff talks, “the new Anglo-French intimacy did not mean there was genuine joint strategic planning. There was joint consultation and some joint discussion,” but there were no plans for closely interlocking Allied operations."), _c('a', {
    attrs: {
      "id": "rch1en22"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Moreover, absent significant political changes, there could be no wartime unity of strategic direction or command of their two armies. The BEF would fight alongside the French army as an independent force, and the two fleets would loosely coordinate their individual actions."), _c('a', {
    attrs: {
      "id": "rch1en23"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" At the outset of war in 1914, the British and French clearly relied instead upon the traditional concept of cooperation between national forces rather than on true unity of strategic direction or command. One should not judge them too harshly, however. Each nation had differing strategic interests that occasionally led them to diverging paths, and neither power had engaged with allies since the Crimean War sixty years earlier. Moreover, as a close student of coalition warfare has observed, “the opening of the First World War occurred while strategists … were emphasizing the national aspects of war to the exclusion of alliance considerations.”"), _c('a', {
    attrs: {
      "id": "rch1en24"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The failure to achieve unity of strategic direction and command would plague coalition efforts throughout the ensuing war. As planned, British and French forces initially operated independently within their delineated zones of operations."), _c('a', {
    attrs: {
      "id": "rch1en25"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" The German envelopment through Belgium during the initial Battle of the Frontier (20–24 August 1914) quickly unhinged the Anglo-French plan. As British and French forces reeled under heavy German pressure, the failure of General Sir John French, BEF commander, to coordinate with the French Fifth Army under General Charles Lanrezac led to a significant gap that risked the entire French defense in Belgium and northern France. Only a direct order to Sir John French from Field Marshal Lord Horatio Kitchener, Britain’s secretary of state for war, to conform to Joffre’s directions restored adequate inter-Allied coordination that allowed the British and French armies eventually to halt the German advance along the Marne River. In doing so, however, French and Joffre suffered multiple episodes of strategic disappointment and distrust that fostered friction between the two armies for the remainder of their respective tenures of command. Differing national interests and objectives during the “race to the sea” that followed the “miracle of the Marne” further exacerbated the sense of distrust and animosity."), _c('a', {
    attrs: {
      "id": "rch1en26"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Although Belgian and British forces briefly operated under Foch’s direction during the First Battle of Ypres in October–November 1914, a lack of common strategic direction continued throughout 1915 and 1916. Debates between proponents of the Western Front and advocates for an emphasis in the eastern Mediterranean, arguments over offensive versus defensive strategies, conflicts over where offensive operations should take place in northwest Europe, and sensitivities over respective casualty levels further heightened tensions.")]), _c('a', {
    attrs: {
      "id": "rch1en27"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Despite defeats and stalemate as well as an Allied agreement at Chantilly on 6 December 1915 that the armies would better synchronize their plans for 1916, each army reverted to national planning in strictly national zones of operation."), _c('a', {
    attrs: {
      "id": "rch1en28"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The German offensive at Verdun that began in February 1916 and ground down the French army for the remainder of the year in a massive battle of attrition and the abortive British offensive on the Somme from July to November 1916 failed to lead to a more coordinated Allied approach to the higher strategic direction of the war."), _c('a', {
    attrs: {
      "id": "rch1en29"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Only a long train of Allied disasters—the continuing meat grinder of Verdun, mutinies in the French army, the massive bloodletting of British Commonwealth forces at Paschendale that cost 350,000–500,000 casualties for a few square miles of mud, increasing shipping losses, the rout of the Italian army at Caporetto, and, most important, the Bolshevik Revolution and Russia’s exit from the war—finally convinced the Allied governments of the need for a centralized organization to coordinate the war."), _c('a', {
    attrs: {
      "id": "rch1en30"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Meeting at Rapollo, Italy, leaders of the British, French, and Italian, but not U.S., governments established the Supreme War Council (SWC) on 7 November 1917. The council consisted of the prime minister and one additional member of government of each power, making it a political rather than military body. Indeed, Prime Minister David Lloyd George saw the SWC as a way to enhance British authority, wrest control of strategy from the military, and reduce rising American influence."), _c('a', {
    attrs: {
      "id": "rch1en31"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Georges Clemenceau, named premier of France ten days after Rapollo—famous for his rebuke “War! this is something too serious to entrust to the military”—also used the SWC to exert his political will over his generals as well as over coalition policy and strategy."), _c('a', {
    attrs: {
      "id": "rch1en32"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each nation also provided a military adviser as a member of the Military Council, a subordinate body of the SWC that oversaw day-to-day operations."), _c('a', {
    attrs: {
      "id": "rch1en33"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" The initial military members included General Sir William Robertson, chief of the Imperial General Staff. Even though the French government initially named General Ferdinand Foch, Clemenceau, upon assuming the premiership, refused to release Foch from his duties as chief of the General Staff and named instead the recently promoted Major General Maxime Weygand, "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Foch’s chief of staff and alter ego. General Luigi Cadorna, recently routed at Caporetto, served as the Italian representative. President Wilson later named General Tasker H. Bliss, former army chief of staff, as the U.S. representative.")]), _c('a', {
    attrs: {
      "id": "rch1en34"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Initially at least, the SWC may have created as many tensions as it resolved. The rapid turnover of early personnel assignments and overall immaturity of political and military staff processes hobbled early efforts. For example, Lloyd George distrusted Robertson and quickly replaced him with the more malleable Lieutenant General Sir Henry Wilson (who had been promoted by this time), though frictions remained. Weygand had only recently received his promotion to major general and was significantly junior to the other military representatives. The disaster at Caporetto had badly tainted Cadorna. Bliss was well respected and trusted, but President Wilson’s absence from the full SWC meant Bliss had no immediate political backing. Not least, Field Marshal Sir Douglas Haig, commander of the BEF, and General Henri-Philippe Pétain, commander in chief (CINC) of the French army, intensely resented the new arrangements, which they perceived as political interference in their operations. Worse, Haig and Pétain quickly recognized that by working together outside the Military Council, they could circumvent the SWC."), _c('a', {
    attrs: {
      "id": "rch1en35"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" As historian William Philpott observes, the result was that “the SWC functioned less as a forum for deciding Allied policy than as a ‘military debating society,’ where Allied differences and resentments could be aired and discussed at length” and issues were frequently left unresolved."), _c('a', {
    attrs: {
      "id": "rch1en36"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" More critical, Elizabeth Greenhalgh concludes that “not only was Versailles [home of the Military Council] a talking shop. It was a trilingual talking shop…. It was also an uneven talking shop.”"), _c('a', {
    attrs: {
      "id": "rch1en37"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite its many shortcomings, the SWC was a step, albeit belated and small, in the right direction. As Greenhalgh concludes, “The SWC marked the transition from political coordination of military policy by conference to coordination by committee.”"), _c('a', {
    attrs: {
      "id": "rch1en38"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" This transition was more important than it may sound. Heretofore, the heads of state had met only episodically and usually only when German successes drove them to assemble. Under the new organization, the permanent military representatives met routinely, sorted through the many competing requirements, resolved what they could, and set the negotiating table for any political decisions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hand in hand with the matter of unity of strategic direction, the prickly issue of unity of command of coalition forces dogged the Allies. Despite the logic of subordinating the much smaller BEF to Joffre’s direction or command, the idea of placing British troops under foreign command was alien to prior British experience."), _c('a', {
    attrs: {
      "id": "rch1en39"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Instructions from Secretary of War Kitchener to Sir John French in August 1914 exemplified the strong British attitudes: “I wish you distinctly "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("to understand that your command is entirely an independent one, and that you will in no case come in any sense under the orders of any Allied General.”")]), _c('a', {
    attrs: {
      "id": "rch1en40"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Strikingly, it appears neither Kitchener nor French communicated these terms to Joffre, nominally the overall coalition commander."), _c('a', {
    attrs: {
      "id": "rch1en41"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Indeed, when Sir Douglas Haig assumed command of the BEF in December 1915, his instructions from Lord Kitchener were virtually identical to those Sir John French received."), _c('a', {
    attrs: {
      "id": "rch1en42"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" The trauma of a year and a half of war had apparently done little to shake the attitudes of 1914. Even during several conferences in 1916, the Allies only loosely coordinated their efforts."), _c('a', {
    attrs: {
      "id": "rch1en43"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Early 1917 saw the first Allied attempt to gain true unity of command. Enamored of General Robert Nivelle, who had replaced Joffre as CINC of the French army, and distrustful of his own commanders, Lloyd George subordinated the British army to Nivelle’s direction for the duration of the spring 1917 offensive. British commanders, aware no doubt of Lloyd George’s political machinations to oust Robertson and Haig, strongly resented the new arrangements."), _c('a', {
    attrs: {
      "id": "rch1en44"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Moreover, British and French staffs planned separately, with only minimal coordination of plans in independent areas of operation."), _c('a', {
    attrs: {
      "id": "rch1en45"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" The Allies only informed one another of their intended actions, in effect providing liaison not unity of command. Although the two armies did cooperate more closely, Lloyd George’s machinations, Nivelle’s personal and professional arrogance, and the dismal failure of the offensive further jaundiced the idea of unified command."), _c('a', {
    attrs: {
      "id": "rch1en46"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a result, the Allies shelved the question of unified command until the collapse of Russia and the Italian debacle at Caporetto once again forced them to address the issue. Facing a likely and massive German attack somewhere on the Western Front in spring 1918, Foch called for establishing a General Allied Reserve, positioned to counter a German offensive in either the British or French sector."), _c('a', {
    attrs: {
      "id": "rch1en47"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Although the rationale for such a reserve made sense, implementation faced substantial obstacles. First, the British and French were convinced that the German attack would fall most heavily on their respective sector and were reluctant to provide forces to the General Reserve. Second, all parties realized that a General Reserve would require a single CINC to control its movements and operation. At this juncture, however, diverging national interests and strategies meant that national commanders placed insufficient trust in each other to submit their forces to a coalition commander or to contribute the forces necessary to compose the reserve."), _c('a', {
    attrs: {
      "id": "rch1en48"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The SWC attempted to skirt the issue of unified command of the General Reserve by establishing an Executive War Board chaired by Foch. Foch proposed that the body, composed of the permanent military representatives of "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("the SWC, with him as president, have responsibility for determining the size of the reserve; the extent of each nation’s contribution; the location of the reserve; the time, place, and period of its employment for the defensive; and, should a counterattack be appropriate, the time, employment, and direction of attack. The SWC ratified Foch’s proposals on 2 February 1918, and by 6 February he had designated each nation’s contribution.")]), _c('a', {
    attrs: {
      "id": "rch1en49"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this point, however, support for the General Reserve began to erode. National commanders naturally hesitated to give up any forces to it. Nevertheless, by the end of February Foch had hammered out agreements with the French and the Italians, and it appeared that the problem might be resolved."), _c('a', {
    attrs: {
      "id": "rch1en50"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" However, the British reply to Foch’s entreaties dealt the General Reserve its deathblow. Haig, having made separate arrangements with Pétain for French support in the event of an attack in the British sector, indicated that he would not provide forces for the General Reserve. His Majesty’s Government affirmed his stand. Foch, in turn, referred the issue back to the SWC for resolution, where it died during the SWC meeting of 14–15 March."), _c('a', {
    attrs: {
      "id": "rch1en51"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The question of the General Reserve would not stay buried, however. Only a week later, on 21 March 1918, the long-anticipated German offensive shattered the Western Front near the juncture of the British and French armies. In accordance with their informal agreement, Haig quickly called upon Pétain for support. An increasing gap between the two armies and French fear of the loss of Paris, however, led Pétain to refuse."), _c('a', {
    attrs: {
      "id": "rch1en52"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Faced with looming catastrophe, Haig proposed during a meeting of British and French representatives at Doullens, France, on 26 March 1918 that Foch “"), _c('i', [_vm._v("should coordinate the actions of the Allied Armies on the Western Front")]), _vm._v(".”"), _c('a', {
    attrs: {
      "id": "rch1en53"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" The British and French governments quickly approved Foch’s appointment. Foch’s power to coordinate the Anglo-French armies did not provide, however, for control of all Allied forces, for the Doullens agreement included neither the Belgian nor the Italian nor the American army. In addition, national commanders retained the right to appeal any decisions to home governments."), _c('a', {
    attrs: {
      "id": "rch1en54"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Continued German successes and uncoordinated Allied efforts eventually forced the realization that Foch’s powers under the Doullens agreement were insufficient and more dynamic action was necessary. Accordingly, General John J. Pershing, commander of the American Expeditionary Force (AEF), subordinated American forces to Foch’s strategic direction on 28 March 1918."), _c('a', {
    attrs: {
      "id": "rch1en55"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Pershing’s offer is a strong indication of the depth of the Allies’ peril. Like his British counterparts, Pershing had strict instructions from Secretary of War Newton D. Baker that “the President directs me to communicate to you the following … the underlying idea must be kept in view that the forces of the "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("United States are a separate and distinct component of the combined forces, the identity of which must be preserved.”")]), _c('a', {
    attrs: {
      "id": "rch1en56"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pershing’s prior experience served him well in carrying out this guidance. The president and first captain of the West Point Class of 1886, Pershing had served on the frontier for more than a decade. His actions at San Juan Hill in the Spanish-American War earned him the admiration of Theodore Roosevelt. In 1905, Pershing married Helen Frances Warren, daughter of the chairman of the Senate Military Affairs Committee. Successful tours in the Philippines burnished Pershing’s reputation and, combined with his marital connection and friendship with Theodore Roosevelt, led to his promotion in 1905 from captain to brigadier general over the heads of 862 more senior officers. In 1916, President Woodrow Wilson placed Pershing in command of the Punitive Expedition pursuing the marauding Pancho Villa, who had been attacking American border towns along the Rio Grande. After having led one of the largest U.S. forces since the Civil War, Pershing was the natural choice to command the AEF upon U.S. entry into World War I in 1917."), _c('a', {
    attrs: {
      "id": "rch1en57"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite Pershing’s subordination of U.S. forces to Foch’s strategic direction, the situation continued to deteriorate. On 3 April, the SWC met at Beauvais and quickly agreed that a single commander of Allied forces was essential to avert defeat. The British, French, and American governments therefore charged General Foch “with the coordination of the action of the Allied armies on the Western Front. To this end, all powers necessary to secure effective realization are conferred on him. The British, French, and American Governments for this purpose entrust to General Foch the strategic direction of military operations.”"), _c('a', {
    attrs: {
      "id": "rch1en58"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" The Beauvais agreement set the conditions for Allied unity of direction and command for the remainder of World War I.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet, although later named CINC of the Allied armies in France, Foch never attained supreme command in the strictest sense."), _c('a', {
    attrs: {
      "id": "rch1en59"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Rather, he directed execution of military strategy. Grand strategy remained the purview of political leaders, and national military leaders controlled operations. National commanders retained the right to appeal Foch’s decisions to their governments, a significant constraint on his command authority. As a result, as General Tasker Bliss later pointed out, Foch “was given no power of command. He could only consult and advise. The result was as one might expect. He had to waste precious time in traveling from one headquarters and the other, persuading commanders to do what he should have been empowered to order.”"), _c('a', {
    attrs: {
      "id": "rch1en60"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" Thus, unable to give orders to the armies under his direction, Foch depended largely on the confidence and personal relationships between him and the various national commanders."), _c('a', {
    attrs: {
      "id": "rch1en61"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Fortunately, as Allied successes accumulated over the summer of 1918, so, too, did Foch’s informal authority. In the final analysis, Foch received the responsibility and authority to provide unity of effort, which is probably the maximum power that any coalition commander can reasonably expect. As General Bliss cogently pointed out, “Unified command came in 1918 at the first moment it could possibly come. Opposition gave way only when it was manifest that every other course had failed. Unified command was accepted, not for the purpose of winning victory but to prevent irretrievable defeat.”")]), _c('a', {
    attrs: {
      "id": "rch1en62"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Concomitant with the struggles over a unified Allied command, sharp differences arose concerning the amalgamation of Allied and especially U.S. units late in the war. At the time, the term "), _c('i', [_vm._v("amalgamation")]), _vm._v(" had a rather broad meaning, varying from the assignment of low-level units—such as army battalions, brigades, and divisions or destroyer squadrons—of one nation to serve under the direction of another nation’s commander. As indicated earlier, with the rare exception of the First Battle of Ypres in October–November 1914, British and French armies operated separately."), _c('a', {
    attrs: {
      "id": "rch1en63"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Once the United States entered the war, however, the seemingly endless pool of American manpower brought amalgamation to the forefront.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The integration of U.S. naval forces with the Royal Navy represents the pinnacle of amalgamation and inter-Allied cooperation during World War I. This success was due to a variety of circumstances. Limited U.S. naval forces were available for service with British allies as early as 24 April 1917, less than three weeks after the United States declared war against Germany. Because naval ships and units normally operate as discrete entities within specified areas of operation, the combined command and control of British and U.S. naval forces was relatively simple. Lastly, because the Royal Navy dwarfed the initial U.S. contribution, it made good sense to subordinate U.S. naval forces to British control.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The assignment of Rear Admiral William S. Sims as the U.S. Navy representative in London may have been the most fortuitous circumstance that facilitated rapid amalgamation of U.S. and British naval forces. As U.S.-German tensions escalated over German unrestricted submarine warfare, Sims, recently assigned president of the Naval War College, was summoned secretly to Washington near the end of March 1917. There, he received instructions to proceed clandestinely to London, in his words, “to get in touch with the British Admiralty and learn how we could best and most quickly cooperate in the naval war.”"), _c('a', {
    attrs: {
      "id": "rch1en64"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Sims was an excellent, if somewhat controversial, choice. On the one hand, born in Canada to American parents, Sims had a well-established reputation as an Anglophile. In fact, President William Howard Taft personally "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("reprimanded Sims in 1910 after Sims delivered a speech in London essentially calling for an Anglo-American union in the event of war with Germany. This attitude also made Sims unpopular with many U.S. naval officers and supporters of U.S. navalism, who, in the words of historian David Trask, “ordinarily viewed the Royal Navy as their principal rival and potential enemy.”")]), _c('a', {
    attrs: {
      "id": "rch1en65"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" On the other hand, Sims was a noted naval reformer and gunnery expert and brought strong professional credentials to the mission. He had served as naval aide to President Theodore Roosevelt and had been the naval attaché in Paris, where he had mastered French. His strong pro-British views and connections in London made it likely, at least in the eyes of CNO Admiral William S. Benson, that Sims would quickly gain British cooperation. That did not stop Benson from admonishing Sims: “Don’t let the British pull the wool over your eyes. It is none of our business pulling their chestnuts out of the fire. We would as soon fight the British as the Germans.”"), _c('a', {
    attrs: {
      "id": "rch1en66"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benson’s attitude was not unique. Since its inception, the U.S. Navy naturally had seen the Royal Navy as its principal rival. A common hangover from the Revolutionary War, a growing trade and financial rivalry, and a general low-level Anglophobia among significant elements of the U.S. population, especially among ethnic Irish and Germans, added to the mix. There had been some recent thawing of relations, leading historian Bradley F. Smith to conclude that “by the eve of World War I, a substantial portion of the American population had come around to perceiving Britain as a strong, but aging and generally benevolent lion.”"), _c('a', {
    attrs: {
      "id": "rch1en67"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" The aging lion still occasionally flexed its muscles, however, and the British blockade policy against Germany and perceived British violations of U.S. neutral rights generated significant anger against Britain."), _c('a', {
    attrs: {
      "id": "rch1en68"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time Sims arrived in London, President Woodrow Wilson had requested a declaration of war against Germany, and Sims immediately began full discussions with members of the British Admiralty. Although the British initially were reluctant to share information, Sims argued that neither he nor the United States could be effective partners without such access. The British soon included him in all their naval planning, and as Sims later noted, “sitting in conference with them every morning, I became, for all practical purposes, a member of their organization.”"), _c('a', {
    attrs: {
      "id": "rch1en69"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Sims worked so closely with his British counterparts that he operated out of an office in the Admiralty rather than following U.S. naval tradition of maintaining his headquarters afloat. Indeed, the degree of cooperation between Sims and the Royal Navy was such that David Trask concludes, “The United States never developed a distinctly independent naval strategy or set of tactics during 1917–1918. Sims helped bring about the acceptance of British ideas.”"), _c('a', {
    attrs: {
      "id": "rch1en70"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Although Sims generally enjoyed smooth sailing in London, he faced much rougher waters in his dealings with Washington. His arrival in Britain coincided with the height of the German U-boat campaign that had Britain on the brink of disaster. The British needed antisubmarine vessels—destroyers, frigates, subchasers—and they needed them at once. Quickly grasping the severity of the situation, Sims urged the immediate dispatch of all available American antisubmarine forces to Europe.")]), _c('a', {
    attrs: {
      "id": "rch1en71"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" The first U.S. destroyers reached Queenstown (now Cobh), Ireland, on 4 May 1917, less than a month after Sims’s arrival in London, and Anglo-American planners quickly integrated the destroyers into the Royal Navy’s operations."), _c('a', {
    attrs: {
      "id": "rch1en72"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nonetheless, the German U-boat campaign picked up momentum. In response, Sims recommended dispatching all available destroyers to the United Kingdom and shifting the U.S. shipbuilding program to the production of merchant marine and antisubmarine craft. Sims’s advice ran into considerable resistance. First, the general unpreparedness of U.S. ships and trained crews to operate them delayed deployment of additional antisubmarine assets. Second, the undeveloped U.S. industrial base would take months to begin producing antisubmarine craft and merchant ships in the quantities desperately needed. Third, no plans existed on a national or coalition basis for the employment of these forces, and British and American naval leaders disagreed on the efficacy of convoy operations. Fourth, U.S. naval leaders were dissatisfied with British naval strategy, believing that reliance on blockade, peripheral operations, and antisubmarine operations was too defensive in nature. Wedded to the theories propounded by the U.S. Navy’s own rear admiral Alfred Thayer Mahan, U.S. Navy leaders wanted a more offensive strategy that would seek a large-scale fleet action with the German High Seas Fleet."), _c('a', {
    attrs: {
      "id": "rch1en73"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" Although not overtly voiced, the immediate dispatch of all destroyers would have stripped the U.S. Fleet of its escort screen. Absent the destroyer screen, the U.S. Fleet could not sortie against the High Seas Fleet. Although the probability of such an engagement had become increasingly unlikely since the Battle of Jutland in June 1916, many American admirals, their thinking deeply rooted in Mahan’s ideas, undoubtedly resented that their battleships would be largely useless. Last, sending only destroyers almost guaranteed their employment under overall British command, leaving the bulk of the U.S. Navy leadership on the sidelines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These latter two points were not simply narrow questions of military ego. President Wilson was concerned that denying the U.S. Navy a major role in the defeat of Germany would weaken U.S. influence at the postwar peace table. Most importantly, a shift to building antisubmarine craft meant deferring the Naval Act of 1916, which focused on building battleships and a “navy second "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("to none.” This last point especially endeared Sims to no one. His recommendation upset most of the leadership of the U.S. Navy. Congressional proponents who favored capital-ship construction and President Woodrow Wilson feared that any delay in the building program of 1916 would permit the Royal Navy to retain its dominance in capital ships in the postwar era.")]), _c('a', {
    attrs: {
      "id": "rch1en74"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After President Wilson and Admiral Benson dispatched Admiral Henry T. Mayo, CINC, U.S. Atlantic Fleet, to Europe for a firsthand review of the situation, Washington eventually agreed with Sims’s proposal. Disagreements still erupted, however, over how best to conduct the antisubmarine campaign. The British, increasingly strangled by the U-boat offensive, naturally wished to concentrate on protecting merchant ships and their precious cargoes of foodstuffs and war materiel. The United States, however, wanted to concentrate on protecting U.S. troop convoys. Because there were few such U.S. troop convoys in 1917, U.S. arguments initially did not prevail. By January 1918, however, naval leaders could no longer defer a decision. The British ultimately acceded to U.S. demands to the point of diverting Royal Navy escorts and supplying troopships at the expense of British commerce."), _c('a', {
    attrs: {
      "id": "rch1en75"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although subsequent events vindicated Sims’s recommendations, his championing of antisubmarine warfare over the battle fleet earned him few friends in the U.S. Navy. Sims also remained suspect in the eyes of his superiors in Washington, who believed him to be too cooperative with the British. Many fellow American officers resented his relationships with the British and feared that he had gone native. This attitude was so widespread that President Wilson commented at the Versailles Peace Conference that Sims ought to be wearing a British, not American, uniform."), _c('a', {
    attrs: {
      "id": "rch1en76"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" Moreover, the deferral of capital-ship construction to build antisubmarine craft, coupled with the limits imposed later under the Washington Naval Treaty of 1922, meant that the U.S. Navy would continue to lag behind the Royal Navy throughout the interwar era."), _c('a', {
    attrs: {
      "id": "rch1en77"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The operational command and control of U.S. naval forces operating in Europe offers an example of smoother inter-Allied cooperation. In the first instance, Sims, as commander of U.S. Naval Forces in European Waters, maintained ultimate command of U.S. vessels scattered around the British Isles. Because of the decentralized nature of U.S. dispositions, however, the Admiralty dispatched all operational orders after consultation and approval by Sims or his staff. Once approved, the British admiral commanding an area where U.S. vessels operated would pass the orders to the senior American naval officer. Depending on circumstances, U.S. ships would operate independently under American command or, if part of a larger force, under control of a British admiral."), _c('a', {
    attrs: {
      "id": "rch1en78"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" These procedures allowed close integration with the Royal Navy, "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("while high command and operational command remained firmly in American hands. This system, established immediately upon the arrival of U.S. naval forces, remained in effect throughout the course of the war.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("This successful integration was due in large part to Sims’s dedication to the principle of Allied cooperation, his rapid and strong support of British strategic concepts and operating methods, and local British and American naval officers maintenance of close working relationships with their counterparts. Two examples highlight the level of Anglo-American cooperation at the operational and tactical levels. In the first instance, when Admiral Rosslyn Wemyss assumed duties as first sea lord, he reorganized the Admiralty to include an American Planning Section within the British Plans Division. This inclusion greatly facilitated development of overall Anglo-American naval strategy and plans, with the Americans frequently providing the impetus behind new initiatives.")]), _c('a', {
    attrs: {
      "id": "rch1en79"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second instance concerned whether Admiral Sir Lewis Bayly, CINC, Irish Coast, should retain control of U.S. naval forces personnel then assigned to his command. Bayly had a well-earned reputation as an irascible and demanding commander, and there was some question in British minds about Bayly retaining his command. However, when the Admiralty queried then U.S. assistant secretary of the navy Franklin D. Roosevelt, Roosevelt recorded in his diary, “I told him frankly that our people from Sims down to the youngest destroyer officer felt that [Bayly] was the ideal man to command this station.”"), _c('a', {
    attrs: {
      "id": "rch1en80"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" The fact that Bayly appointed Captain Joel Pringle of the U.S. Navy as his chief of staff contributed to this sense of satisfaction with Bayly’s style of command. So dedicated was Bayly to coalition cooperation that when he went on leave, he insisted that Sims assume command of all operations, one of the few times in history that Royal Navy forces served under the flag of an American admiral."), _c('a', {
    attrs: {
      "id": "rch1en81"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Historians have largely agreed with the participants about the successful amalgamation and unity of command within Anglo-American naval forces. British historian Arthur Marder, the leading authority on the Royal Navy of this period, concludes that “the general harmony of Anglo-American naval effort is a rare exception in the annals of wartime relations among allies.”"), _c('a', {
    attrs: {
      "id": "rch1en82"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" American historian David R. Woodward opines, “Eventually, Anglo-American naval cooperation saw a level of amalgamation never achieved by land forces with the British and the French,” although he adds the caveat, “but not without serious disagreements over priorities and strategy.”"), _c('a', {
    attrs: {
      "id": "rch1en83"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" At the operational level, in particular the nexus between Bayly and Sims, great credit must go to Sims, who early on set the tone for his relationships with his British counterparts: “I believe there is no case on record where allies have cooperated together for any "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("considerable time without more or less serious friction. I am out to make an exception in this mater ["), _c('i', [_vm._v("sic")]), _vm._v("].”")]), _c('a', {
    attrs: {
      "id": "rch1en84"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The amalgamation of U.S. ground forces into British or French armies proceeded on an entirely different course. Although there were several good reasons for these differing paths, without a doubt, national and personal pride were involved. In addition, some key leaders, such as General Tasker Bliss, thought that amalgamation would lead to too great a loss of inadequately trained American lives. However, only one key consideration really mattered: the AEF’s role in securing a coalition victory would determine the level of influence that the United States could wield at the peace table."), _c('a', {
    attrs: {
      "id": "rch1en85"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" As David Trask observes, “This elemental decision was consistent with the president’s intention to avoid political commitments that might compromise his peace plans while making an essential contribution to victory over the Central Powers.”"), _c('a', {
    attrs: {
      "id": "rch1en86"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" Thus, the president’s guidance circumscribed American policies on amalgamation. It also meant the mobilization of a large army that would sail to France to fight independently under its own commanders, using its own doctrine, in its own sector, “to strike the decisive blow against the German army.”"), _c('a', {
    attrs: {
      "id": "rch1en87"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" These essential principles would guide Wilson’s principal agent, General John J. Pershing, throughout the course of the war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Adhering to these principles was not easy. Even before U.S. entry into the war, British military leaders argued for enlisting U.S. personnel directly into the British, Canadian, or French armies, thereby eliminating the prolonged time required to create an independent American army. Once the United States formally entered into war, Lieutenant General Sir Tom Bridges, British army representative on the Balfour Mission in the United States to coordinate military and supply efforts, suggested to U.S. Army chief of staff General Hugh Scott that the United States forgo creating its own army and instead send 500,000 men immediately to Britain to undergo training and employment by the British army. Once aware of Bridges’s proposal, however, President Wilson quickly quashed the idea, though it would continue to resurface over the next year and a half."), _c('a', {
    attrs: {
      "id": "rch1en88"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marshal Joffre, also in the United States on an initial coordination mission, likewise argued for the rapid transportation of individual U.S. replacements for training and employment in French units."), _c('a', {
    attrs: {
      "id": "rch1en89"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" Joffre got no further than Bridges. Contrary to his British counterpart, however, Joffre quickly recognized that the Americans would never tolerate such a proposition and accepted the early arrival of a single American division as a means to boost French morale."), _c('a', {
    attrs: {
      "id": "rch1en90"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" This initial recognition of American sensitivities also laid the groundwork for U.S.-French cooperation that would grow considerably over time. Coincidentally, "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("President Wilson decided that because the U.S. Navy already was cooperating with the Royal Navy, the bulk of the AEF would cooperate with the French army. Whether there was a direct cause and effect is unknown, however, in the wake of the failed Nivelle Offensive, pairing the AEF with the French army made sense. Regardless of reason, the vast majority of the AEF would train with the French army, would receive the bulk of its heavy weapons, equipment, and artillery support from French sources, and would fight predominantly alongside French forces—but as independent American units.")]), _c('a', {
    attrs: {
      "id": "rch1en91"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even with President Wilson’s decisions, Pershing continuously had to fend off rising Allied pressure for more extensive amalgamation."), _c('a', {
    attrs: {
      "id": "rch1en92"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" Although the Allies initially agreed to employ U.S. ground forces in divisional or larger units under their own commanders, Allied reverses throughout 1917 made it seem that only the immediate use of American manpower spelled the difference between victory and defeat."), _c('a', {
    attrs: {
      "id": "rch1en93"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" With the British and French armies nearing exhaustion in December 1917, Pétain approached Pershing about integrating U.S. forces into French divisions at the regimental or even battalion level. Irrevocably devoted to the principle of an independent American command, Pershing adamantly rejected the proposal but did offer the entire First Infantry Division should an emergency require early employment of U.S. forces."), _c('a', {
    attrs: {
      "id": "rch1en94"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To reduce manpower deficiencies, in January 1918 the British proposed using their shipping assets to transport 150 independent U.S. infantry battalions to France for training and service with the BEF. Pershing tentatively agreed with the plan, but only after expressing strong reservations."), _c('a', {
    attrs: {
      "id": "rch1en95"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" In his memoirs, however, he remarked that he did not seriously object to Haig’s plan because he saw it as a way to get additional shipping assets for faster transport of American units to France and that “it was not my intention at any time to agree to amalgamation in any permanent sense with either of the Allies.”"), _c('a', {
    attrs: {
      "id": "rch1en96"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" Problems later developed over the implementation of the plan, not least President Wilson’s objections, and the Allies shelved it in favor of the Six Division Plan, where the British agreed to ship six complete U.S. divisions to France to train under British supervision prior to assimilation into the AEF. Pershing recommended acceptance of the plan to the War Department. Although President Wilson eventually agreed to it, he admonished: “[Only] a ‘sudden and manifest emergency’ should be allowed to ‘interfere with the building up of a great distinct American force at the front, acting under its own flag and its own officers.’”"), _c('a', {
    attrs: {
      "id": "rch1en97"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" After working out the details, U.S. regiments or divisions trained and went into the trenches to gain combat experience under command of British or French division or corps commanders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("When the Germans launched their climactic offensive in March 1918, it soon became apparent that the Allies needed more American units brought on line. Although steadfastly refusing wholesale incorporation of American forces, Pershing grudgingly acknowledged that prompt attachment of certain American forces to the British and French armies would be necessary to stop the Germans. He accordingly placed elements of the AEF at Foch’s disposal on 28 March. Pershing nonetheless specified that amalgamation would be temporary and occur at no lower than division level, so that the American divisions would retain unit integrity and the ability quickly to transfer back to an eventual independent American army.")]), _c('a', {
    attrs: {
      "id": "rch1en98"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" Foch immediately began to reposition U.S. divisions—starting with the transfer of the First Infantry Division into the British zone—usually to quiet sectors where they relieved more veteran Allied units for active campaigning. Over the next eight months, twenty-five U.S. divisions, thirty infantry brigades, nine field artillery brigades, and numerous smaller, specialized detachments would serve with the French. Nine U.S. divisions served with the British army."), _c('a', {
    attrs: {
      "id": "rch1en99"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pershing’s concession did not end matters as German advances throughout April brought the British and French armies to the brink of collapse. British and French political leaders once again pressured Wilson for wholesale amalgamation of individual U.S. soldiers as well as units. In doing so, they failed to reckon with Wilson’s dedication to an independent American army. The British especially grossly miscalculated when Lloyd George instructed Rufus Isaacs, marquess of Reading, the British ambassador to the United States, to convey to Wilson: “We can do no more than what we have done. It rests with America to win or lose the decisive battle of the war.”"), _c('a', {
    attrs: {
      "id": "rch1en100"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" Wilson, so irate that he refused to see the ambassador, later commented in a cabinet meeting, “[I] fear that I will come out of the war hating [the] British.”"), _c('a', {
    attrs: {
      "id": "rch1en101"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" After his temper cooled, his eventual response superficially supported amalgamation but contained caveats that fully preserved U.S. freedom of action. Colonel E. M. House, Wilson’s trusted adviser, also informed Reading that this was Wilson’s “last word on the subject.” Reading, acknowledging defeat, cabled London that “the American position should be accepted, not only without raising any objection, but also without having any in mind.”"), _c('a', {
    attrs: {
      "id": "rch1en102"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor did the British and French fare any better with Pershing. Despite intense pressure, the AEF commander obdurately refused to consider any further initiatives that might jeopardize an independent American army. These arguments raged throughout May and into June. Only one account of a highly acrimonious exchange at the Allied conference at Versailles during 1–2 June 1918 is necessary to convey the levels of frustration on both sides.")]), _vm._v(" "), _c('p', {
    staticClass: "stylet"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCH")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSHING")]), _vm._v("): You are willing to risk our being driven back to the Loire [River]?")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "style"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSHING:")]), _vm._v(" Yes, I am willing to take that risk.")]), _vm._v(" "), _c('p', {
    staticClass: "style"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOYD")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EORGE:")]), _vm._v(" Well, we will refer it to your President.")])]), _c('p', {
    staticClass: "style"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSHING:")]), _vm._v(" Refer it to the President and be damned. I know what the President will do. He will simply refer it back to me for recommendation and I will make the same recommendation as I have made here today.")]), _c('a', {
    attrs: {
      "id": "rch1en103"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Despite Pershing’s outburst, the Allies did not relent. Even after Pershing placed the Second and Third Infantry Divisions in active operations under French corps commanders and was preparing to introduce even more divisions into combat under higher-level British and French commanders, the Allies continued to press Wilson and Pershing throughout June and July. Only when the last offensive planned by General Erich Ludendorff, de facto leader of the German army, stalled in mid-July and the Allies moved to the counteroffensive did calls for amalgamation finally subside—but not disappear."), _c('a', {
    attrs: {
      "id": "rch1en104"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The mixing of forces affected not only American forces but French and British units as well. During the final Allied offensive of 1918, French contingents (division and higher) were attached to the American command for combat operations."), _c('a', {
    attrs: {
      "id": "rch1en105"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" The assignment of British units with American forces occurred on a less-extensive basis. Except for artillery and transportation, only small, specialized elements of the British army served under U.S. command during the final battles because the British refused to place any of their fighting divisions under a U.S. corps commander."), _c('a', {
    attrs: {
      "id": "rch1en106"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" A snub not forgotten that would color future Anglo-American collaboration for years to come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the eleventh hour of the eleventh day of the eleventh month of 1918, the guns finally fell silent on the Western Front. The Great War was over. Yet keen observers reckoned that this peace would be temporary. Foch remarked at the signing of the Versailles Peace Treaty, “This is not a peace. It is an armistice of twenty years.”"), _c('a', {
    attrs: {
      "id": "rch1en107"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" From the other side of the hill, German diplomat Count Harry Kessler noted in his diary, “Today the Peace Treaty was ratified in Paris; the War is over. A terrible era begins for Europe, like the gathering of clouds before a storm, and it will end in an explosion probably still more terrible than that of the World War.”"), _c('a', {
    attrs: {
      "id": "rch1en108"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Given the likelihood of such an outcome, what lessons or insights could or should have British and U.S. military leaders garnered? The coalition experience reinforced Clausewitz’s dictum that “war is a continuation of politics by other means.”"), _c('a', {
    attrs: {
      "id": "rch1en109"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" Each partner fought for its national interests and guarded "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("those interests dearly, sometimes at the expense of coalition cohesion. Such conditions made difficult the design of coherent coalition policies and grand strategy and argued for a political decision-making body to oversee the higher direction of the war effort. Unfortunately, it took more than three years of fighting, the loss of hundreds of thousands of lives, and the virtual exhaustion of the British and French armies before the looming German offensives of 1918 finally forced the Allies to form the Supreme War Council.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite its many warts, the SWC nonetheless provided an advantage over the previous ad hoc conferences called to deal with the crisis of the moment. Moreover, political leaders recognized that effective strategic oversight by the SWC required a permanent military body to provide advice. Although political machinations reduced the effectiveness of the Military Council, it still represented a dramatic improvement in military advice relative to the vacuum that had previously existed. Similarly, exigencies, not foresight, eventually drove the coalition to appoint Foch as generalissimo. In practice, however, the most Foch could do was convince, cajole, and sometimes browbeat national commanders into complying with his guidance. Fortunately for the coalition, Foch adeptly managed the national commanders and their egos. In his role, Foch had what all high-level coalition commanders must have: the confidence of respective national political leaders and the trust of the military leaders of national contingents. In sum, people and personalities matter, especially in coalitions.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Reflections from a participant in this drama echo these conclusions. From 1934 to 1940, Major General Fox Conner, the G3 operations officer of the AEF, delivered an annual lecture at the U.S. Army War College entitled “The Allied High Command and Allied Unity of Direction.” His preface, emphasizing that “dealing with the enemy is a simple and straight-forward matter when contrasted with securing close cooperation with an ally,” set the tone for his address.")]), _c('a', {
    attrs: {
      "id": "rch1en110"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" At the end of his presentation, he summarized what he believed to be the lessons in coalition warfare derived from the experiences of World War I. These insights, which would influence future U.S.-British military collaboration, bear recounting in detail:")]), _vm._v(" "), _c('p', {
    staticClass: "nlistt"
  }, [_vm._v("1.  National Pride plays some, though a small, part in preventing or postponing Unity of Direction and Unity of Command.")]), _vm._v(" "), _c('p', {
    staticClass: "nlist"
  }, [_vm._v("2.  The ulterior motives of the several members of a Coalition form the principal obstacle to securing either Unity of Direction or Unity of Command.")]), _vm._v(" "), _c('p', {
    staticClass: "nlist"
  }, [_vm._v("3.  With the exception of America and possibly Belgium, all Nations, or rather the Politicians of all Nations, in the World War were "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("filled with ulterior motives, and with grandiose ideas of the “Compensations” they would obtain at the peace table. It is likely to be so again.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "nlist"
  }, [_vm._v("4.  With the exceptions noted, all Nations were “jockeying” for postwar “positions.”")]), _vm._v(" "), _c('p', {
    staticClass: "nlist"
  }, [_vm._v("5.  “Open Covenants, openly arrived” is beyond the realities of European statesmanship or politics. One is constantly reminded of Captain Peter Wright’s tribute to the Americans at the Supreme War Council:—“They were all quite untouched by the taint of bad faith and personal calculation that seems to load the air where the great are.”")]), _vm._v(" "), _c('p', {
    staticClass: "nlist"
  }, [_vm._v("6.  As between Allies so opposed in racial characteristics, as well as National interests, as the British, the French, the Italians, and Americans, only an actual or a threatened catastrophe is likely to bring about anything approaching either Unity of Direction or Unity of Command.")]), _vm._v(" "), _c('p', {
    staticClass: "nlist"
  }, [_vm._v("7.  In spite of the assertion just made, America should, if she ever indulges in the doubtful luxury of entering another Coalition, advocate, coincident with entering a war with Allies, the establishment of a Supreme War Council. Such an institution is primarily necessary to provide decent interment for “Fool Schemes.”")])]), _c('p', {
    staticClass: "nlist"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("8.  Unity of Command should be sought, at least between Allies of equal standing, in matters of strategy only. It is quite hopeless to expect a worth-while Nation, unless it reaches the state of Austria in 1916 and 1917, to surrender the tactical command of its troops.")]), _c('a', {
    attrs: {
      "id": "rch1en111"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#ch1en111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Like its individual parts, the overall record of British and American experiences in coalition partnerships before and during World War I reveals mixed progress. The evidence suggests that the level of cooperation within the coalition varied considerably, as the partners hesitantly groped toward a semblance of coalition unity. Although oftentimes the journey was uncoordinated, disjointed, and replete with multiple fits and starts, by the end of the war the Allies had achieved modest progress, however episodic. Whether these many lessons were lessons lived and learned or lived and lost is explored more fully in the examination of Anglo-American coalition experiences in the interwar period.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d061c1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/15_Chapter01.vue
// module id = 99
// module chunks = 0